import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between px-5 pt-4 pb-2" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 3,
  class: "text-center"
}

import {reactive, computed, shallowRef, watch, ref} from 'vue';
import {consultationService} from '@/api/services/consultation';
import {useSettingsStore} from '@/api/store/settings';
import {filterValues, sortValues} from '@/views/AppointmentsEvents/Helpers';
import ButtonFilterSelect from "@/components/custom/ButtonFilterSelect/ButtonFilterSelect.vue";
import SearchFilter from "@/components/custom/SearchFilter.vue";
import debounce from 'lodash/debounce';
import AppointmentsCard from "@/views/AppointmentsEvents/AppointmentsCard.vue";
import ButtonBase from "@/components/custom/ButtonBase.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentsView',
  setup(__props) {

const settingsStore = useSettingsStore();
const loading = ref(false);

// Data
const state = reactive({
  consultations: [] as any[],
  pagination: {
    meta: {},
    links: [],
  },
  search: '' as string,
  filterSelected: 'filter' as string,
  tab: 'upcoming',
});

// Sort and Filter state
const sortTabSelectedValue = shallowRef({
  name: 'Sort',
  label: 'Sort'
})
const filterTabSelectedValue = shallowRef({
  name: 'Filter',
  label: 'Filter'
})

// Pagination state
const page = shallowRef(1)

// Computed
const filterQueryString = computed(() => {
  let filter = {
    sorting: '',
    search: state.search,
    page: page.value,
    tab: state.tab,
    searching: 'name'
  };

  let sortOrder = sortTabSelectedValue.value.name === 'Sort' ? 'desc' : sortTabSelectedValue.value.name;

  let filterValue = filterTabSelectedValue.value.name === 'Filter' ? 'name' : filterTabSelectedValue.value.name;

  if (filterTabSelectedValue.value.name === 'Filter' && sortTabSelectedValue.value.name === 'Sort') {
    filter.sorting = 'id,desc';
  } else {
    if (filterValue === 'upcoming' || filterValue === 'past' || filterValue === 'canceled') {
      filter.tab = filterValue;
      filter.sorting = `id,${sortOrder}`;
    } else {
      filter.sorting = `${filterValue},${sortOrder}`;
    }
  }

  return filter;
});

const getConsultations = () => {
  loading.value = true;

  consultationService.index({ ...filterQueryString.value, skipGlobalLoading: true }).then((response) => {
    const withEvents = response.data.filter(item => item.event);
    const withoutEvents = response.data.filter(item => !item.event);

    state.consultations = [...withEvents, ...withoutEvents];
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
  }).finally(() => {
    loading.value = false;
  });
}

// Debounced to fetch getMedicalAlerts
const debouncedGetOrders = debounce(getConsultations, 300);

const resetState = () => {
  page.value = 1;
  state.consultations = [];
}

const seeMore = () => {
  if (state.pagination.links.next) {
    page.value++;
    getConsultations();
  }
}

watch(() => [filterTabSelectedValue.value, sortTabSelectedValue.value, state.search, state.tab], () => {
  resetState();
  debouncedGetOrders();
});

getConsultations();

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pt-0 mb-12 position-relative",
    style: {"background-color":"#F0F0F0","min-height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "mt-0 mb-2 py-5 text-center",
        "no-gutters": "",
        style: {"background-color":"#FFF"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(SearchFilter, {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => state.search = val)
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex px-3",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[2] || (_cache[2] = ()=>state.filterSelected = 'sort')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: sortTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortTabSelectedValue).value = $event)),
                    "is-tab-selected": state.filterSelected === 'sort',
                    items: _unref(sortValues),
                    multiple: false,
                    text: sortTabSelectedValue.value,
                    icon: "sort-icon",
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "items", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[4] || (_cache[4] = ()=> state.filterSelected = 'filter')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: filterTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterTabSelectedValue).value = $event)),
                    "is-tab-selected": state.filterSelected === 'filter',
                    items: _unref(filterValues),
                    multiple: false,
                    text: filterTabSelectedValue.value,
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "items", "text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        class: "text-center py-0",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            class: "d-flex px-4",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(ButtonBase, {
                    "custom-class": ['transparent text-black', {'secondary-button text-white': state.tab === 'upcoming'}],
                    text: "Upcoming",
                    width: "100%",
                    onClick: _cache[5] || (_cache[5] = () => state.tab = 'upcoming')
                  }, null, 8, ["custom-class"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(ButtonBase, {
                    "custom-class": ['transparent text-black', {'secondary-button text-white': state.tab === 'past'}],
                    text: "Past",
                    width: "100%",
                    onClick: _cache[6] || (_cache[6] = () => state.tab = 'past')
                  }, null, 8, ["custom-class"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(ButtonBase, {
                    "custom-class": ['transparent text-black', {'secondary-button text-white': state.tab === 'cancelled'}],
                    text: "Cancelled",
                    width: "100%",
                    onClick: _cache[7] || (_cache[7] = () => state.tab = 'cancelled')
                  }, null, 8, ["custom-class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(4, (n) => {
            return _createVNode(_component_v_card, {
              key: n,
              class: "font-size-12-400 mx-5 my-3",
              style: {"border-radius":"10px","border":"1px solid #F0F0F0","box-shadow":"0.5px 0.5px 15px 0px #0000000D"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_skeleton_loader, {
                    type: "text",
                    width: "120"
                  }),
                  _createVNode(_component_v_skeleton_loader, {
                    type: "text",
                    width: "80"
                  })
                ]),
                _createVNode(_component_v_sheet, {
                  class: "pa-4",
                  style: {"display":"grid","grid-template-columns":"1fr 4fr 1fr","align-items":"center","border-radius":"30px","gap":"8px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, { type: "avatar" }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_skeleton_loader, {
                        type: "text",
                        width: "70%",
                        class: "mb-2"
                      }),
                      _createVNode(_component_v_skeleton_loader, {
                        type: "text",
                        width: "50%",
                        class: "mb-2"
                      }),
                      _createVNode(_component_v_skeleton_loader, {
                        type: "text",
                        width: "40%"
                      })
                    ]),
                    _createVNode(_component_v_skeleton_loader, {
                      type: "button",
                      width: "82"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          }), 64))
        : (_openBlock(), _createElementBlock("section", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.consultations, (consultation) => {
              return (_openBlock(), _createBlock(AppointmentsCard, {
                key: consultation.id,
                consultation: consultation,
                tab: state.tab
              }, null, 8, ["consultation", "tab"]))
            }), 128))
          ])),
      (!loading.value && state.consultations.length == 0)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 2,
            class: "mt-4 mx-4 mb-3",
            height: "50vh"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "my-2 py-1",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "my-1 px-10 text-center",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_alert, {
                        type: "info",
                        variant: "tonal"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("No " + _toDisplayString(state.tab) + " Found", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (state.pagination.links.next)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              ripple: false,
              class: "load-more text-capitalize font-size-12-600",
              variant: "plain",
              onClick: seeMore
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Load More ", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})